import { render } from "./LeadOpeningInterval.vue?vue&type=template&id=68140d42&scoped=true"
import script from "./LeadOpeningInterval.vue?vue&type=script&lang=js"
export * from "./LeadOpeningInterval.vue?vue&type=script&lang=js"

import "./LeadOpeningInterval.vue?vue&type=style&index=0&id=68140d42&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68140d42"]])

export default __exports__